import { render } from "./PrivilegeDialog.vue?vue&type=template&id=0df3cd14&scoped=true"
import script from "./PrivilegeDialog.vue?vue&type=script&lang=js"
export * from "./PrivilegeDialog.vue?vue&type=script&lang=js"

import "./PrivilegeDialog.vue?vue&type=style&index=0&id=0df3cd14&scoped=true&lang=css"

import exportComponent from "D:\\yiban\\WebProject\\yiban-admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0df3cd14"]])

export default __exports__